import { render, staticRenderFns } from "./MarketingCard.vue?vue&type=template&id=4e3b50b3&scoped=true&"
import script from "./MarketingCard.vue?vue&type=script&lang=js&"
export * from "./MarketingCard.vue?vue&type=script&lang=js&"
import style0 from "./MarketingCard.vue?vue&type=style&index=0&id=4e3b50b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3b50b3",
  null
  
)

export default component.exports